// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2IFrg","title":"AfterFrontImage_title__1-9aP"};